import React from 'react';
import './sec3.css'
import Titles from '../components/common/titles';
import Cardsec3 from '../components/common/card-sec3';
import pic8 from '../assets/pic8.png'
import pic9 from '../assets/pic9.png'
import pic10 from '../assets/pic10.png'
import pic11 from '../assets/pic11.png'
import pic12 from '../assets/pic12.png'
import pic13 from '../assets/pic13.png'

const Sec3 = () => {
    return ( 
        <section className='sec3'>
            <article className='container-sec3'>
               
                         <Titles title='Who We Are' stylee='title-center'/>
                        <figure className='container-cards-sec3'>

                            <Cardsec3 imgg={pic8}  title='Verde Heights' 
                            para='Green, spacious, and elevated lifestyle.'/>

                            <Cardsec3 imgg={pic9}  title='Imperial Grove' 
                            para='Exclusive and thoughtfully crafted.'/>


                            <Cardsec3 imgg={pic10}  title='Emerald Crest' 
                            para='Graceful and thoughtfully planned.'/>


                            <Cardsec3 imgg={pic11}  title='Opal Heights' 
                            para='Crafted for comfort and calm.'/>


                             <Cardsec3 imgg={pic12}  title='Harmony Grove' 
                            para='Balanced and naturally inspired.'/>          


                             <Cardsec3 imgg={pic13}  title='Skyline Haven' 
                            para='Modern and perfectly located.'/>         
                        </figure>
            </article>
        </section>
     );
}
 
export default Sec3;